// noinspection JSUnusedGlobalSymbols

export enum DnsTypes {
    A = 'A',
    AAAA = 'AAAA',
    CNAME = 'CNAME',
    DNAME = 'DNAME',
    MX = 'MX',
    NS = 'NS',
    SRV = 'SRV',
    TXT = 'TXT'
}
